import { useState, useEffect } from 'react';

const STORAGE_KEY = 'bullivo_theme';

function applyTheme(theme) {
  if (theme === 'system') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', theme);
  }
}

export function useTheme() {
  const [theme, setThemeState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || 'light'; } catch { return 'light'; }
  });

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  const setTheme = (val) => {
    try { localStorage.setItem(STORAGE_KEY, val); } catch {}
    setThemeState(val);
  };

  return { theme, setTheme };
}
